import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router'

// Components
import { App } from '../../../App';
import { ModelList } from '../../../components/PaginatedList/ModelList';


// Redux
import { searchAlbum, restoreAlbum, createAlbum } from '../Album/redux/album.actions';
import { FullAlbums } from '../Album/redux/album.selectors';
import { FullLibraries } from './redux/library.selectors';
import { hasAccess, TERM_ALBUM, TERM_RECENT, useActiveItem } from '../../services/CaptureCollabService';
import { NewContent } from '../../../components/Content/NewContent';
import { HorizontalStack, SmartContainer, Stack, StyledGridItem, Surface } from '../../../styles/Containers';
import { AlbumList } from '../Album/AlbumList';
import { LibraryNavigation } from './LibraryNavigation';
import { useParams } from 'react-router-dom';
import { getLibrary } from './redux/library.actions';
import { Photostream } from '../Photostream/Photosteam';
import { StyledH3 } from '../../../styles/StyledHTML';
import { Role } from '../../../redux/Auth/auth.selectors';
import { searchPermissions, useMyPermissions } from '../Permission/redux/permissions.actions';
import { NoPermissions } from '../Permission/NoPermissions';
import { RouteBreadCrumbs } from '../../../routes';
import { DefaultContentCard } from '../../components/Content/DefaultContentCard';
import { PermissionsEditor } from '../Permission/PermissionsEditor';
import { FullPermissions } from '../Permission/redux/permissions.selectors';
import { StyledIconButton } from '../../../styles/matieralui/IconButton';
import { IconSettings } from '../../Icons';
import { StyledButton } from '../../../styles/matieralui/Button';
import { FullScreenLoader } from '../../components/Layout/FullScreenLoader';
import { TopLevelNavigation } from '../../components/Dashboard/TopLevelNavigation';

export const LibraryAlbumsPage = () => {

    // New Modal
    const dispatch = useDispatch();
    const storeLibraries = FullLibraries();
    const { id } = useParams();
    const [filters, setFilters] = useState({});
    const currentUserRole = Role();
    const { permissions, hasPermission, getPermissionRole, permissionChecked } = useMyPermissions();
    const [noAccess, setNoAccess] = useState(false);
    const [myRole, setMyRole] = useState(null);
    const storeAlbums = FullAlbums();

    const { activeId, activeItem, activeModel, activeLoading } = useActiveItem({ id, model: 'Libary', selector: FullLibraries, getAction: getLibrary })

    // Redirect
    useEffect(() => { if (storeAlbums.createSuccess) dispatch(push(`/library/${id}/album/${storeAlbums?.create?.id}/upload`)) }, [storeAlbums?.createLoading])

    // Check Permissions
    useEffect(() => {


        if (hasPermission('Library', id)) {
            const r = getPermissionRole('Library', id);
            setNoAccess(false);
            setMyRole(r);
        } else {

            setNoAccess(true);
        }

    }, [permissions])

    // --------------------------
    // Interactions
    // --------------------------

    // On Select
    const handleSelect = (item) => {
        dispatch(push(`/library/${id}/album/${item.id}`))
    }

    // --------------------------
    // Renders
    // --------------------------
    const renderTopBarChildren = () => {

        // if (noAccess) return null;

        // return (
        //     <SmartContainer flex align="center" justify="flex-end">
        //         {myRole !== 'viewer' && (<NewContent buttonText="create a new album" label="new album" selector={FullAlbums} createAction={createAlbum} args={{ LibraryId: id }} />)}
        //     </SmartContainer>
        // )
        if (noAccess) return null;

        return (
            <SmartContainer flex align="center" justify="flex-end">

                {id && activeItem && (myRole === 'owner' || myRole === 'admin') && (
                    <PermissionsEditor
                        modelId={activeItem?.id}
                        model="Library"
                        selector={FullPermissions}
                        action={searchPermissions}
                    />
                )}
                {id && (myRole === 'owner' || myRole === 'admin') && (<StyledIconButton onClick={() => dispatch(push(`/library/${id}/settings`))}><IconSettings /></StyledIconButton>)}
                <HorizontalStack flex>
                    {/* {myRole !== 'viewer' && (<NewContent buttonText="New Album" label="New Album" selector={FullAlbums} createAction={createAlbum} args={{ LibraryId: id }} />)} */}
                    {myRole !== 'viewer' && (<StyledButton variant='contained' color="blue" onClick={() => dispatch(push(`/library/${id}/upload`))}>Upload</StyledButton>)}
                </HorizontalStack>
            </SmartContainer>
        )

    }

    const renderPageNavigation = () => {
        return (<TopLevelNavigation />)
        // return (<LibraryNavigation libraryId={id} />)
    }

    const pushControls = () => {
        const controls = [];//'newalbum', 'recent', 'nothing'];
        if (myRole !== 'viewer') controls.push('newalbum');
        controls.push('recent')
        return controls.map(i => {
            if (i === 'newalbum') return renderNewAlbum();
            if (i === 'recent') return renderRecent();
        })
    }

    const renderNewAlbum = () => {
        if (noAccess) return null;
        if (myRole === 'viewer') return null;
        return (
            <StyledGridItem key="newalbum">
                <Surface flex justify="center" align="center" width="100%">
                    <NewContent iconHelperText={`New ${TERM_ALBUM}`} label={`New ${TERM_ALBUM}`} selector={FullAlbums} createAction={createAlbum} args={{ LibraryId: id }} />
                </Surface>
            </StyledGridItem>
        )
    }
    const renderRecent = () => {
        if (!activeItem) return null;
        const formatted = {
            id: activeItem.id,
            title: "Recent",
            description: "Recent",
            full: { ...activeItem, name: "Recent Uploads" }
        }
        return (
            <StyledGridItem key={formatted.id}>
                <DefaultContentCard content={formatted} onClick={() => dispatch(push(`/library/${id}`))} model="Library" />
            </StyledGridItem>
        )
    }

    const title = (activeItem) ? activeItem?.name : "Loading...";


    // Album Filters
    const albumFilters = { LibraryId: `["${id}"]` };

    //-- TODO: Remove
    // albumFilters.order = `[["name", "DESC"],["createdAt","DESC"]]`;


    // Render Page
    return (
        <App title={title}
            pageNavigation={renderPageNavigation}
            topBarChildren={renderTopBarChildren()}
            breadcrumbs={[RouteBreadCrumbs.libraries, { href: `/library/${id}`, title: TERM_RECENT }]}
        >
            {!activeItem && (<FullScreenLoader />)}
            {activeItem && (
                <SmartContainer width="100%">

                    {(noAccess || permissionChecked === 'notchecked') && (<NoPermissions checked={permissionChecked} />)}
                    {(!noAccess && permissionChecked !== 'notchecked') && (
                        <Stack>
                            <AlbumList onSelect={handleSelect} filters={albumFilters} libraryId={id} />
                        </Stack>
                    )}
                </SmartContainer>
            )}

        </App>
    )
}